// extracted by mini-css-extract-plugin
export default {"field":"priceField_field__GgrH+"};